import { styled } from '@styles/stitches';

export const Container = styled('div', {
  display: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '$primaryBackground',
  zIndex: 1,

  '@bp1': {
    display: 'flex',
    padding: '$space$2',
  },
});

export const Key = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '$space$5',
});
